import React from "react";

import MultiPartFormLayout from "../flows/MultipartForm";
import useTransactionsUploader from "../../hooks/transactionsCsvUploader";

const VendorInputForm = ({ setOpen, isSliderLeftContent }) => {
  const transactionsCsvUploaderSteps = useTransactionsUploader({
    open: true,
    setOpen,
  });

  return (
    <MultiPartFormLayout
      type="vendors"
      forms={transactionsCsvUploaderSteps}
      onClose={!isSliderLeftContent && (() => setOpen(false))}
      submitLoadingText="Please wait while we load your new vendors..."
      style={isSliderLeftContent && { right: "40%" }}
    />
  );
};
export default VendorInputForm;
